export default __webpack_public_path__ + "static/media/diners.27e804af.svg";